import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * TODO: DELETE THIS FILE (and the `cookie-policy` route folder) once classic ships links to `/cookies`
 * on the info host. Then run `yarn vite build` so `routeTree.gen.ts` drops `/cookie-policy`.
 *
 * Until then: `/cookie-policy` → `/cookies` on the info app for old classic URLs.
 */
export const Route = createFileRoute('/cookie-policy')({
  beforeLoad: () => {
    throw redirect({ to: '/cookies', replace: true });
  },
});
